import { LoadOptions } from 'devextreme/data/load_options';

import HttpClient from '@utils/httpClient';

const service = {
  getReport(loadOptions: LoadOptions) {
    return HttpClient.post(`/api/userOperationInfo/report`, loadOptions).then((resp) => {
      return resp.data;
    });
  },

  updateInfo(ids: string[], loadStationCode: number | null, destStationCode: number | null) {
    return HttpClient.post('/api/userOperationInfo/info', { ids, loadStationCode, destStationCode }).then((resp) => {
      return resp.data;
    });
  },
};
export default service;
